__turbopack_context__.v({
  "hamburgerButton": "hamburgerButton-module-scss-module__7fA7Ha__hamburgerButton",
  "icon": "hamburgerButton-module-scss-module__7fA7Ha__icon",
});
